// Facebook/Meta Pixel & Conversion Tracking Helper
// Pixel ID: 1942581856297832

const FACEBOOK_PIXEL_ID = '1942581856297832';

/**
 * Initialize Facebook Pixel
 * Should be called once when app loads
 */
export const initFacebookPixel = () => {
  if (window.fbq) return; // Already initialized

  // Facebook base code
  const loadFacebookPixel = (f, b, e, v, n, t, s) => {
    if (f.fbq) return;
    n = f.fbq = function() {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  };

  loadFacebookPixel(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js'
  );

  window.fbq('init', FACEBOOK_PIXEL_ID);
  window.fbq('track', 'PageView');
};

/**
 * Track a Facebook event
 * @param {string} eventName - Facebook standard event name
 * @param {object} data - Event parameters
 */
export const trackFacebookEvent = (eventName, data = {}) => {
  if (window.fbq) {
    window.fbq('track', eventName, data);
  }
};

/**
 * Track a custom Facebook event
 * @param {string} eventName - Custom event name
 * @param {object} data - Event parameters
 */
export const trackFacebookCustomEvent = (eventName, data = {}) => {
  if (window.fbq) {
    window.fbq('trackCustom', eventName, data);
  }
};

/**
 * Pre-defined Facebook events for DesiFirms
 */
export const facebookEvents = {
  // Track page view (called automatically on init)
  pageView: () => trackFacebookEvent('PageView'),

  // Track user registration
  completeRegistration: (email = '') => {
    trackFacebookEvent('CompleteRegistration', {
      content_name: 'User Registration',
      status: true,
    });
  },

  // Track lead (inquiry, contact form)
  lead: (contentName = 'Inquiry', contentCategory = '') => {
    trackFacebookEvent('Lead', {
      content_name: contentName,
      content_category: contentCategory,
    });
  },

  // Track search
  search: (searchString) => {
    trackFacebookEvent('Search', {
      search_string: searchString,
    });
  },

  // Track content view (business, deal, event)
  viewContent: (contentName, contentType, contentId = '') => {
    trackFacebookEvent('ViewContent', {
      content_name: contentName,
      content_type: contentType,
      content_ids: contentId ? [contentId] : [],
    });
  },

  // Track when user starts listing their business
  initiateCheckout: (contentName, value = 0, currency = 'AUD') => {
    trackFacebookEvent('InitiateCheckout', {
      content_name: contentName,
      value: value,
      currency: currency,
    });
  },

  // Track subscription/purchase
  subscribe: (planName, value = 0, currency = 'AUD') => {
    trackFacebookEvent('Subscribe', {
      value: value,
      currency: currency,
      predicted_ltv: value * 12,
    });
  },

  // Track contact (WhatsApp click, email click, phone click)
  contact: () => {
    trackFacebookEvent('Contact');
  },

  // Custom: Business listing created
  businessCreated: (businessName, category = '') => {
    trackFacebookCustomEvent('BusinessListingCreated', {
      content_name: businessName,
      content_category: category,
    });
  },
};

const facebookPixel = {
  init: initFacebookPixel,
  track: trackFacebookEvent,
  trackCustom: trackFacebookCustomEvent,
  events: facebookEvents,
};

export default facebookPixel;
